export default __webpack_public_path__ + "static/const-four-13a9747bbbcf6f97943084e70eff81db.png";